module.exports = __webpack_public_path__ + "assets/img/linkedin-icon-on-white.38b468cb.svg";